/**
 * Embed protocol — constants shared between apps/api and apps/web
 * (EMB-09). A single source of truth for the marker header the embed shell
 * sends on every request so the backend knows to prefer the in-memory
 * bearer token over a stale first-party cookie (see
 * apps/api/middleware/auth.js `getTokenFromRequest`, apps/web/src/lib/api.js
 * `apiFetch`) — never hand-copy this string into either side.
 */
export const EMBED_MARKER_HEADER = 'x-twc-embed'
